var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4130_215)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4130_215",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4130_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9989 0.0093689C19.2542 0.0114579 14.6171 1.41976 10.6733 4.05749C6.72938 6.69522 3.65578 10.4432 1.84201 14.8275C0.0282361 19.2118 -0.443176 24.0363 0.48451 28.6894C1.4122 33.3425 3.69805 37.6152 7.05451 40.9687C10.411 44.3223 14.6875 46.6058 19.3414 47.5294C23.9953 48.453 28.8187 47.9764 33.2014 46.1587C37.5841 44.3411 41.3278 41.2643 43.962 37.3181C46.5963 33.3719 48.001 28.7334 47.9989 23.9887C47.9933 17.6272 45.4623 11.5276 40.962 7.03124C36.4617 2.53494 30.3604 0.00936643 23.9989 0.0093689Z",
    fill: "#1C1F2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.579 32.4843C27.5913 32.5779 27.5812 32.6725 27.5509 32.7618C27.5205 32.8512 27.4695 32.9332 27.4028 32.9999C27.336 33.0667 27.2558 33.1177 27.1665 33.1481C27.0772 33.1784 26.9826 33.1866 26.889 33.1743H22.5765C22.483 33.1866 22.3865 33.1784 22.2971 33.1481C22.2078 33.1177 22.1276 33.0667 22.0609 32.9999C21.9942 32.9332 21.9431 32.8512 21.9128 32.7618C21.8824 32.6725 21.8742 32.5779 21.8865 32.4843V22.0912H18.5865C18.493 22.1035 18.3983 22.0934 18.309 22.0631C18.2197 22.0327 18.1376 21.9817 18.0709 21.9149C18.0042 21.8482 17.9531 21.768 17.9228 21.6787C17.8924 21.5893 17.8842 21.4929 17.8965 21.3993V17.0868C17.8842 16.9933 17.8924 16.8968 17.9228 16.8074C17.9531 16.7181 18.0042 16.6379 18.0709 16.5712C18.1376 16.5045 18.2197 16.4534 18.309 16.4231C18.3983 16.3927 18.493 16.3827 18.5865 16.3949H26.9959C27.449 16.3949 27.5565 16.632 27.5565 16.9556V32.4843H27.579Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4130_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneLogin);
export default __webpack_public_path__ + "static/media/OneLogin.1c0ed0509dc9d774b39bcf522ca11d28.svg";
export { ForwardRef as ReactComponent };